/**
 * @desc: - loading遮罩 
 * @param  {[bool]} display: [是否显示遮罩]
 * @param  {[string]} text : [icon下方文字]
 * @author: circle
 */
import React from 'react';
export default class LOADING extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
      let {display} = this.props;
      const className = display ? 'overlay-mask' : '';
      return (
          <div className={className}>
                  <p></p>
          </div>
      );
  }
}